import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './styles/Unslider.module.scss';
import useSwipe from "../../hooks/useSwipe";
import Button from "./Button";
import FontAwesome from "./FontAwesome";
import {CSSTransition} from 'react-transition-group';

const slideClassNames = {
    enter: styles.transitionEnter,
    enterActive: styles.transitionEnterActive,
    enterDone: styles.transitionEnterDone,
    exit: styles.transitionExit,
    exitActive: styles.transitionExitActive,
    exitDone: styles.transitionExitDone,
};

const Unslider = (props: {
    children: JSX.Element[],
    delay?: number,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [autoplay, setAutoplay] = useState(true);

    function handleNext() {
        setCurrentIndex(v => v + 1 === props.children.length ? 0 : v + 1);
    }

    function handlePrev() {
        setCurrentIndex(v => v - 1 === 0 ? props.children.length - 1 : v - 1);
    }

    const swipe = useSwipe({handleRightSwipe: handleNext, handleLeftSwipe: handlePrev})

    useEffect(() => {
        let t;
        if (autoplay) {
            t = setTimeout(handleNext, props.delay);
        }
        return () => clearTimeout(t);
    }, [autoplay, currentIndex])

    return <div ref={swipe} className={styles.container}>
        {props.children.map((child, index) => {
            return <CSSTransition key={index} in={index === currentIndex} classNames={slideClassNames} timeout={1000}>
                <div className={styles.slide}>
                    {child}
                </div>
            </CSSTransition>
        })}
        <div className={styles.controls} style={{zIndex: props.children.length + 1}}>
            {props.children.map((_, i) => {
                return <button
                    key={i}
                    style={{background: i === currentIndex ? "white" : "transparent"}}
                    className={styles.indicator}
                    onClick={() => setCurrentIndex(i)}
                    aria-label={'Slide ' + (i + 1)}
                />
            })}
            <Button onClick={() => setAutoplay(v => !v)} className={styles.pause} aria-label={autoplay ? 'Pause Slideshow' : 'Start Slideshow'}>
                <FontAwesome prefix={'fas'} name={autoplay ? 'fa-pause' : 'fa-play'}/>
            </Button>
        </div>
    </div>
}

Unslider.propTypes = {
    delay: PropTypes.number,
}

Unslider.defaultProps = {
    delay: 5000,
}

export default Unslider;